export const CRYPTO_SECRET_KEY = 'eyJzdWIiOiJyaW1hYy1zYWx1ZC1mbGV4aWJsZSIsImlhdCI6MTUxNjIzOTAyMiwiYWxnIjoiSFMyNTYifQ';
export const CRYPTO_KEY_BIT_LENGTH = 128;
export const CRYPTO_ITERATIONS = 100;
export const CRYPTO_LENGTH_DIV = 32;
export const ONE_STEP_SALFLEX = 'ONE-STEP-SALFLEX';
